<template>
    <div  :class="colClasseCss">
        <div class="content-rotulo" :class="!this.vertical ? 'rotulo-vertical' : 'rotulo-horizontal'">
            <div class="label-rotulo p-col-fixed label-destaque">
                <label >{{ nome }} <span v-if="requerido" style='color: red;'>*</span></label>
            </div>
            <div class="p-col elemento">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import gridCss from '../common/grid'

export default {
    name: 'RotuloSeplag',
    props: {
        nome: {
            // Especifica a Label do Rotulo
            type: String,
            default: ''  
        }, 
        vertical: {
            // Especifica o posicionamento do Formulário
            type: Boolean,
            default: null  
        }, 
        cols: {
            // Especifica o numero posição do elemento da Grid
            type: String
        }, 
        requerido: {
            // Informa se tela deve exibido a legenda o * de obrigatoriedade , default=false    
            type: Boolean, 
            default: false     
        }
    },
    computed: {
        colClasseCss() {
            // Carrega a Grid Css
            let classeCss = gridCss(this.cols ? this.cols : '12')
            // Retorna as classes CSS customizadas    
            return classeCss
        }
    }

}
</script>

<style scoped>
.rotulo-horizontal {
    display: flex;
    flex: 1;
    align-items: center;
    flex-flow: wrap;
}

.rotulo-vertical {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
}

.p-col-1, .p-col-2, .p-col-3, .p-col-4, .p-col-5, .p-col-6, .p-col-7, .p-col-8, .p-col-9, .p-col-10, .p-col-11, .p-col-12 {
     padding-top: 0;
     
} 

.content-rotulo .p-col, .content-rotulo .label-rotulo{
    padding: 0;
}

.rotulo-vertical .p-col {
    padding-top: 0.3em;
}

.rotulo-horizontal .label-rotulo {
    padding-right: 0.3em;
} 

.label-destaque {
    font-weight: 600;
    color: rgb(110, 106, 106);
}

</style>